import React from 'react';
import PropTypes from 'prop-types';
import { Dropdown } from 'antd';
import { CaretDown } from '@phosphor-icons/react';
import Button from '../Button';
import { captureAnalytics } from '../../actions/preload';

const ActionDropdown = ({
  label, icon, menu, disabled,
}) => (
  <Dropdown
    overlay={menu}
    trigger={['click']}
    disabled={disabled}
    onVisibleChange={(visible) => {
      if (visible) captureAnalytics('record_viewer_action_menu_opened', { action: label });
    }}
  >
    <span>
      <Button type="tertiary" size="small" label={label} leftIcon={icon} rightIcon={<CaretDown size={14} />} disabled={disabled} aria-haspopup="menu" />
    </span>
  </Dropdown>
);

ActionDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  menu: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
};
ActionDropdown.defaultProps = { disabled: false };

export default ActionDropdown;
